import LegalPage from "./LegalPage";
import { privacyBlocks } from "./privacyContent";

export default function PrivacyPolicyPage() {
  return <LegalPage title="Privacy Policy" blocks={privacyBlocks} />;
}
